import request from '@/common/js/request'

export const userUidGet = (option = {}) => request({
    url: '/apis/user/{uid}',
    method: 'get',
    ...option
})

export const bindPhonePost = (option = {}) => request({
    url: '/apis/bind/phone',
    method: 'post',
    ...option
})

export const refreshTokenPost = (option = {}) => request({
    url: '/apis/refresh-token',
    method: 'post',
    ...option
})

export const logoutPost = (option = {}) => {
    return request({
        url: '/node-apis/logout',
        method: 'post',
        ...option
    })
}

export const dialCodesGet = (option = {}) => {
    return request({
        url: '/apis/dial-codes',
        method: 'get',
        ...option
    })
}
